import { Ajax } from "../../Common/Ajax";
import { GlobalData } from "../../Common/GlobalData";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";
import { StockPickList } from "../../Common/StockPickList";

export class PivotPointChanges {
    private readonly DISPLAY_BLANK = 'displayBlank';
    private readonly DISPLAY_SHOW_ALL = 'displayShowAll';
    private readonly DISPLAY_HIDE_BLANKS = 'displayHideBlanks';
    private readonly DISPLAY_SHOW_ONLY_BLANKS = 'displayShowOnlyBlanks';
    private readonly GRID = '#grid';
    private readonly SPINNER = '#spinner';

    private gridDataSource!: kendo.data.DataSourceOptions;

    private static _instance: PivotPointChanges;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.init();
    }

    private init() {
        this.initRadioButtons();

        this.gridDataSource = {
            transport: {
                update: {
                    url: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_PIVOT_POINT_CHANGES,
                    type: 'PUT',
                    contentType: 'application/json',
                    dataType: 'json',
                },

                parameterMap: function (options: any, operation: any) {
                    if (operation !== "read" && options.models) {
                        return kendo.stringify(options.models);
                    }
                }
            },
            batch: true,
            schema: {
                model: {
                    id: "symbol",
                    fields: {
                        symbol: { type: "string", editable: false, nullable: false },
                        pivotNote1: { type: "string", editable: false, nullable: false },
                        changed: { type: "boolean", editable: true, nullable: true },
                        blank: { type: "boolean", editable: true, nullable: true },
                        aFlag: { type: "number" },
                        ppPercent: { type: "number" },
                        needsUpdating: { type: "number" },
                    }
                }
            },
        };

        const stockPickList = new StockPickList(this.GRID,
            GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_PIVOT_POINT_CHANGES, null, this.gridDataSource);

        $(this.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            height: 915,
            editable: true,
            navigatable: false,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            toolbar: [
                { name: "save" },
                { name: "cancel" },
            ],
            columns: [
                {
                    field: 'symbol',
                    title: 'Sym',
                    width: '40px',
                    sortable: true,
                    headerAttributes: { style: "text-align: center; font-size: 13px; font-weight: bold" },
                    attributes: { style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "pivotNote1",
                    title: "PivotNote1",
                    width: "120px",
                    sortable: true,
                    headerAttributes: { style: "text-align: center; font-size: 13px; font-weight: bold" },
                    attributes: { style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "aFlag",
                    hidden: true,
                },
                {
                    field: "ppPercent",
                    hidden: true,
                },
                {
                    title: "C",
                    width: "30px",
                    sortable: true,
                    headerAttributes: { style: "text-align: left; font-size: 12px; font-weight: bold" },
                    attributes: { style: "text-align: left" },
                    template: kendo.template(TemplateHelpers.getCheckboxTemplate('changed')),
                },
                {
                    title: "B",
                    width: "30px",
                    sortable: true,
                    headerAttributes: { style: "text-align: left; font-size: 12px; font-weight: bold" },
                    attributes: { style: "text-align: left" },
                    template: kendo.template(TemplateHelpers.getCheckboxTemplate('blank')),
                },
            ]
        });

        this.defineEvents();
    }

    private initRadioButtons() {
        $('[name=' + this.DISPLAY_BLANK + ']').on('change', (event: any) => {
            const selection = event.currentTarget.id;
            const grid = $(this.GRID).data('kendoGrid')!;
            const items = grid.dataSource.view();
            // Keep track of alt row for applying/removing k-alt CSS class
            let altRow = false;
            let rowShown = false;

            for (let i = 0; i < items.length; i++) {
                const $row = $(this.GRID).find("[data-uid='" + items[i].uid + "']");

                if (selection == this.DISPLAY_SHOW_ALL) {
                    $row.show();
                    rowShown = true;
                }
                else if (selection == this.DISPLAY_HIDE_BLANKS) {
                    if (items[i].blank) {
                        $row.hide();
                    }
                    else {
                        $row.show();
                        rowShown = true;
                    }
                }
                else if (selection == this.DISPLAY_SHOW_ONLY_BLANKS) {
                    if (items[i].blank) {
                        $row.show();
                        rowShown = true;
                    }
                    else {
                        $row.hide();
                    }
                }

                if (rowShown) {
                    altRow ? $row.addClass("k-alt") : $row.removeClass("k-alt");
                    altRow = !altRow;
                    rowShown = false;
                }
            }
        });
    }

    private defineEvents() {
        // Update value of the field when user clicks a checkbox.
        $('#grid .k-grid-content').on('change', 'input.previousCheckbox', (e: any) => {
            const dataItem = this.getClosestDataItem(e);
            const newValue = e.target.checked;
            dataItem.set('previous', newValue ? true : false);
            if (newValue) {
                dataItem.set('changed', false);
                dataItem.set('blank', false);
                dataItem.set('old', false);
            }
        });
        $('#grid .k-grid-content').on('change', 'input.changedCheckbox', (e: any) => {
            const dataItem = this.getClosestDataItem(e);
            const newValue = e.target.checked;
            dataItem.set('changed', newValue ? true : false);
            if (newValue) {
                dataItem.set('previous', false);
                dataItem.set('blank', false);
                dataItem.set('old', false);
            }
        });
        $('#grid .k-grid-content').on('change', 'input.blankCheckbox', (e: any) => {
            const dataItem = this.getClosestDataItem(e);
            const newValue = e.target.checked;
            dataItem.set('blank', newValue ? true : false);
            if (newValue) {
                dataItem.set('previous', false);
                dataItem.set('changed', false);
                dataItem.set('old', false);
            }
        });
        $('#grid .k-grid-content').on('change', 'input.oldCheckbox', (e: any) => {
            const dataItem = this.getClosestDataItem(e);
            const newValue = e.target.checked;
            dataItem.set('old', newValue ? true : false);
            if (newValue) {
                dataItem.set('previous', false);
                dataItem.set('changed', false);
                dataItem.set('blank', false);
            }
        });

        // Clear changed and sortOrder fields when user clicks the clear button.
        $('#clearButton').on('click', () => {
            kendo.confirm('Are you sure that you want to initialize PivotPoint data?')
                .then(() => {
                    this.clear();
                });
        });
    }

    private clear() {
        const message = new Notification();
        $(this.SPINNER).show();

        const success = () => {
            $(this.GRID).data('kendoGrid')!.dataSource.read();
            message.success('Finished');
        };

        const error = () => {
            message.error('Error');
        };

        const complete = () => {
            $(this.SPINNER).hide();
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_PIVOT_POINT_CHANGES +
            '/ClearChanges', 'PUT', null, success, error, complete);
    }

    private getClosestDataItem(e: any) {
        const grid = $(this.GRID).data('kendoGrid')!;
        return grid.dataItem($(e.target).closest('tr'));
    }

    //private getDataItem(index: number) {
    //    const grid = $(this.GRID).data('kendoGrid');
    //    return grid.dataItem('tbody tr:eq(' + index + ')');
    //}
}


